<template>
  <div>
    <v-switch :value="type">
      <template #simple>
        <SimpleTransformSummary v-model="summary[0].options" />
      </template>
    </v-switch>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import VSwitch from '@/components/VSwitch.vue';
import SimpleTransformSummary from '@/components/summary/transform/SimpleTransformSummary.vue';

export default defineComponent({
  name: 'TransformSummary',
  components: {
    VSwitch,
    SimpleTransformSummary,
  },
  computed: {
    ...mapState({
      type: (state: any) => state.transform.type,
    }),
    ...mapGetters({
      summary: 'transform/config',
    }),
  },
});
</script>
